import React from 'react';
import { companyInfo, servicesList, serviceAreas } from '../data/mock';

const SchemaMarkup = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "@id": "https://graycontractingdfw.com/#organization",
    "name": companyInfo.name,
    "alternateName": "Gray Contracting DFW",
    "description": companyInfo.description,
    "url": "https://graycontractingdfw.com",
    "telephone": companyInfo.phone,
    "email": companyInfo.email,
    "foundingDate": "1969",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.addressStreet,
      "addressLocality": companyInfo.addressCity,
      "addressRegion": companyInfo.addressState,
      "postalCode": companyInfo.addressZip,
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "32.8378",
      "longitude": "-96.7691"
    },
    "areaServed": serviceAreas.map(area => ({
      "@type": "City",
      "name": area,
      "containedInPlace": { "@type": "State", "name": "Texas" }
    })),
    "priceRange": "$$",
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], "opens": "07:00", "closes": "18:00" },
      { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "08:00", "closes": "14:00" }
    ],
    // Note: AggregateRating removed per Google guidelines - self-serving ratings on own business pages
    // Real reviews should be collected via Google Business Profile
    "slogan": "Quality Painting & Remodeling You Can Trust"
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      { "@type": "Question", "name": "What services does Gray Contracting offer?", "acceptedAnswer": { "@type": "Answer", "text": "Gray Contracting offers residential painting, remodeling, drywall repair, carpentry, tile installation, exterior siding, deck construction, and mold remediation throughout Dallas-Fort Worth." }},
      { "@type": "Question", "name": "How long has Gray Contracting been in business?", "acceptedAnswer": { "@type": "Answer", "text": "Gray Contracting is a family-owned business with over 55 years of experience serving Dallas-Fort Worth since 1969." }},
      { "@type": "Question", "name": "Is Gray Contracting licensed and insured?", "acceptedAnswer": { "@type": "Answer", "text": "Yes, Gray Contracting is fully licensed and insured, including specialized certifications for lead and mold remediation work." }}
    ]
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": companyInfo.name,
    "url": "https://graycontractingdfw.com",
    "logo": companyInfo.logoDark,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": companyInfo.phone,
      "contactType": "customer service",
      "areaServed": "US"
    }
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
    </>
  );
};

export default SchemaMarkup;
